import { PATHS } from 'Utils/PagePaths';

export const data = [
  {
    title: "Introduction",
    level: 1,
    content: "The Common Formats for Event Reporting - Diagnostic Safety Version 1.0 (CFER-DS V1.0) are designed for use across all healthcare settings and specialties. Widespread use of the CFER-DS and reporting to the PSOPPC/NPSD will make it possible to collect, aggregate and analyze diagnostic safety-related information nationally to accelerate learning and improvement.",
  },
  {
    level: 1,
    title: "Collect Data",
    content: <><strong>Collect Data from Providers</strong>: Prepare your patient safety event information using the Diagnostic Safety Version 1.0 Common Format. The resources provided below including the Data Dictionary, Users' Guide, Form, and Flow Chart, will help you understand required data elements, answer values, and validation rules before you create your submission files.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [2576, 2573, 2572, 2571, 2581, 2575, 2580, ]
      },
    ]
  },
  
  {
    level: 1,
    title: "Submit Data",
    content: <><strong>Submit Data to NPSD</strong>: Submit your patient safety event data to the PSOPPC using the Diagnostic Safety Version 1.0 Common Format. These resources walk you through the process for both CDA XML and Alternate Data Submission formats, including an Implementation Guide, Resources Workbook, and Sample Files. For more information before you get started, see the <a href={PATHS.public['Submit Data']}>Submit Data</a> page.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [2574, 2578, 2042, 2579, 2756, 2758, 2582, 2577, 2757, ],
      },
    ]
  },

]